// src/mocks/handlers/auth/authHandlers.schema.ts

import { z } from 'zod';

// const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"|,.<>?]).{8,}$/;

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string(),
});

export const tokenSchema = z.object({
  email: z.string().email(),
  password: z.string(),
  otp: z.string().min(6).max(6), // Assume 6 digit OTP
});

export const passwordResetSchema = z.object({
  email: z.string().email(),
});
